import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    api.post("/auth/google/session", { session_id: sessionId })
      .then((res) => {
        setUser(res.data);
        // Strip hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Welcome to the maison.", { description: `Signed in as ${res.data.email || res.data.name || ""}` });
        navigate("/account", { replace: true });
      })
      .catch(() => {
        toast.error("Could not complete sign-in. Please try again.");
        navigate("/", { replace: true });
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-midnight">
      <div className="text-center">
        <div className="eyebrow mb-4 text-silver/80">Establishing session</div>
        <div className="font-serif text-white text-3xl">One moment…</div>
      </div>
    </div>
  );
}
